import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

import { VolumeInfo } from "@/components/PaintConfigurator/paintConfigurator.types";
import { Mapped } from "@/context/mapped.context";

type VolumesContextValue = {
    volumes: Array<VolumeInfo>;
};

type VolumesContextProviderProps = RequireChildrenFor<{
    volumes?: Map<string, VolumeInfo>;
}>;

export const VolumesContext = createContext<VolumesContextValue | undefined>(
    undefined
);
VolumesContext.displayName = "VolumesContext";

export const VolumesContextProvider = ({
    volumes = new Map<string, VolumeInfo>(),
    children
}: VolumesContextProviderProps) => {
    return (
        <VolumesContext value={{ volumes: Array.from(volumes.values()) }}>
            <Mapped array={Array.from(volumes.keys())}>{children}</Mapped>
        </VolumesContext>
    );
};

export const useVolumesContext = () => {
    const context = use<VolumesContextValue | undefined>(VolumesContext);

    if (!isDefined(context)) {
        throw new Error(`${VolumesContext.displayName} is undefined.`);
    }

    return context;
};
